<router-outlet></router-outlet>

<app-secondary-nav-clients [clientIn]="customer"></app-secondary-nav-clients>
